import React, { useState, useEffect } from "react";
import { postData } from "../api/protectedApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TransactionLayout from "../component/dashboard/TransactionLayout";
import { handleExportData } from "../utils/exportUtils";
import { callDataByEndpoint } from "../utils/dataUtils";

const WithdrawHistory = () => {
  const [transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const limit = 10;

  const callData = (page) => {
    callDataByEndpoint("/user/withrawOrders", {
      page,
      limit,
      setData: setTransactions,
      setTotalCount,
      setIsLoading,
    });
  };

  useEffect(() => {
    callData(currentPage);
  }, [currentPage]);

  const handleExport = (type) => {
    handleExportData({
      endpoint: "/user/withrawOrders",
      columns,
      fallbackData: transactions,
      filename: "withdrawal_history",
      type,
      postDataFn: postData,
      toastFn: toast,
    });
  };

  const filteredTransactions = transactions.filter((t) => {
    const q = searchQuery.toLowerCase();
    return (
      (t.walletAddress && t.walletAddress.toLowerCase().includes(q)) ||
      (t.remarks && t.remarks.toLowerCase().includes(q)) ||
      (t.status && t.status.toLowerCase().includes(q)) ||
      (t.amount && t.amount.toString().includes(q))
    );
  });

  const columns = [
    { key: "id", label: "ID" },
    { key: "amount", label: "Amount" },
    { key: "payable", label: "Payable" },
    { key: "remark", label: "Remark" },
    { key: "address", label: "Wallet Address" },
    { key: "status", label: "Status" },
    { key: "date", label: "Date" },
  ];

  return (
    <TransactionLayout
      title="Withdrawal History"
      subtitle="Audit your past withdrawal requests, payable balances, and transfer approvals."
      searchQuery={searchQuery}
      onSearchChange={(q) => { setSearchQuery(q); setCurrentPage(1); }}
      searchPlaceholder="Search by wallet, status, remark, or amount..."
      onExport={handleExport}
      cardTitle="Withdrawal Ledger"
      cardSubtitle="Real-time withdrawal records"
      columns={columns}
      data={filteredTransactions}
      isLoading={isLoading}
      emptyMessage="No Withdrawal Transactions Found."
      pagination={{
        currentPage,
        totalCount,
        limit,
        onPageChange: (page) => setCurrentPage(page),
      }}
    />
  );
};

export default WithdrawHistory;
